import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useHistory } from "react-router-dom";

import {
  DoctorIcon,
  NurseIcon,
  SubcareIcon,
  TelemedIcon,
  AmbulanceIcon,
  MedicineIcon
} from "@speedoc/design-assets/build/icons";
import { Link } from "react-router-dom";
import SectionHeading from "./sectionHeading";
import ProductCard from "./productCard";
import MobileServiceCard from "./mobileServiceCard";
import Slider from "react-slick";
import { slugToCountryPathname } from "../../utils/strings";

function Symbol({ name }) {
  if (name === "doctor") {
    return <DoctorIcon />;
  } else if (name === "nurse") {
    return <NurseIcon />;
  } else if (name === "ambulance") {
    return <AmbulanceIcon />;
  } else if (name === "medicine_delivery") {
    return <MedicineIcon />;
  } else if (name === "subsidized_care") {
    return <SubcareIcon />;
  } else if (name === "videoconsultation") {
    return <TelemedIcon />;
  }
  return null;
}

const PrevArrow = props => {
  const { className, onClick } = props;
  return <button onClick={onClick} className={className} />;
};

const NextArrow = props => {
  const { className, onClick } = props;
  return <button onClick={onClick} className={className} />;
};

export default function ServicesSlider({ content }) {
  const isTablet = useMediaQuery({ query: "(max-width: 992px)" });
  const [isAnimated, setIsAnimated] = useState();
  const history = useHistory();

  const settings = {
    infinite: true,
    speed: 500,
    fade: false,
    autoplaySpeed: 600000,
    autoplay: true,
    dots: false,
    draggable: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    initialSlide: 0,
    cssEase: "cubic-bezier(0.165, 0.840, 0.440, 1.000)",
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />
  };

  const startAnimate = index => {
    return new Promise(resolve => {
      setIsAnimated(index);
      setTimeout(resolve, 600);
    });
  };

  const endAnimate = index => {
    return new Promise(resolve => {
      setIsAnimated(undefined);
      setTimeout(resolve, 200);
    });
  };

  const goToLink = slug => {
    history.push(slugToCountryPathname(slug));
  };

  const handleOnTouch = async (index, slug) => {
    await startAnimate(index);
    await endAnimate(index);
    if (slug) await goToLink(slug);
  };

  return (
    <div id="servicesSlider">
      <SectionHeading title={content.title} subtitle={content.subtitle} />
      {isTablet ? (
        content.entries.map((entry, index) => (
          <div key={index} onClick={e => handleOnTouch(index, entry.page.slug)}>
            <MobileServiceCard
              isAnimated={isAnimated === index}
              title={entry.title}
              description={entry.description}
              symbol={<Symbol name={entry.icon} />}
            />
          </div>
        ))
      ) : (
        <Slider {...settings}>
          {content.entries.map((entry, index) => (
            <Link className="productCardLink" to={slugToCountryPathname(entry.page?.slug)} key={index}>
              <ProductCard
                title={entry.title}
                image={entry.image?.url}
                description={entry.description}
                symbol={<Symbol name={entry.icon} />}
              />
            </Link>
          ))}
        </Slider>
      )}
    </div>
  );
}
